export default __webpack_public_path__ + "static/media/loading.e2ffacc9.gif";